import React from 'react';
import AddCTA from '../component/common/addcta';
import pic24 from '../assets/pic24.png'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import pic29 from '../assets/pic29.png'
import Header2 from '../component/common/title';
import { useState } from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import Input from '../component/common/input';
import Cta from '../component/common/cta';
import pic30 from '../assets/pic30.png'
import Textarea from '../component/common/textarea';
import Selectinput from '../component/common/selectinput';
import pic31 from '../assets/pic31.png'
import './categories-content.css'
import pic44 from '../assets/pic44.png'
import Errormsginput from '../component/common/errormsginput';

const Categoriescontent = () => {



const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [sort, setSort] = useState('');

const [errors, setErrors] = useState({});

const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 6;


         const [categories, setCategories]= useState([]);

        useEffect(() => {
        const getCategories = async()=>{
            const res = await supabase.from('category').select('*').order('id', { ascending: true });;
        setCategories(res.data);
        }
        getCategories();
        }, []);




const filteredCategories = categories
  .filter((item) =>
    item.category_name?.toLowerCase().includes(search.toLowerCase()))
  .filter((item) => {
    if (filter === "") return true;
      if (filter === "true") return item.status === true;
    if (filter === "false") return item.status === false;
    return true;
  });
 


const totalPages = Math.ceil(filteredCategories.length / itemsPerPage);

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;

const currentCategories = filteredCategories.slice(startIndex, endIndex);








const [links, setLinks] = useState([]);

useEffect(() => {
  const getLinks = async () => {
    const res = await supabase
      .from("exhibitor_categories")
      .select("*");

    setLinks(res.data || []);
  };

  getLinks();
}, []);




const getStatusLabel = (status) => {
  return status ? "Active" : "Inactive";
};

const getStatusClass = (status) => {
  return status ? "status-confirmed" : "status-cancelled";
};





// // this is my create function we el edit


const [editingId, setEditingId] = useState(null);

const [open, setOpen] = useState(false);
const [form, setForm] = useState({
  category_name: "",
  img_alt: "",
  status: true,
   image: "", 
    exhibitors: [] 
});



const [exhibitors, setExhibitors] = useState([]);

useEffect(() => {
  const getExhibitors = async () => {
    const res = await supabase.from("exhibitors").select("*");
    setExhibitors(res.data || []);
  };

  getExhibitors();
}, []);






const addExhibitorSelect = () => {
  setForm((prev) => ({
    ...prev,
    exhibitors: [...prev.exhibitors, ""]
  }));
};

const updateExhibitor = (value, index) => {
  const updated = [...form.exhibitors];
  updated[index] = value;

  setForm((prev) => ({
    ...prev,
    exhibitors: updated
  }));
};


const removeExhibitor = (index) => {
  const updated = [...form.exhibitors];
  updated.splice(index, 1);

  setForm((prev) => ({
    ...prev,
    exhibitors: updated
  }));
};



const handleSubmit = async (e) => {
  e.preventDefault();

 let hasError = false;
  const newErrors = {};


if (!form.category_name) {
    newErrors.category_name = "Category name is required";
    hasError = true;
  }


  if (!form.exhibitors || form.exhibitors.length === 0) {
    newErrors.exhibitors = "At least one exhibitor is required";
    hasError = true;
  }

  setErrors(newErrors);

  if (hasError) return;










  let categoryId = editingId;

  if (editingId) {
    const { data, error } = await supabase
      .from("category")
      .update({
        category_name: form.category_name,
        img_alt: form.img_alt,
        image: form.image,
        status: form.status
      })
      .eq("id", editingId)
      .select()
      .single();

    if (error) return console.log(error.message);

    categoryId = data.id;

    await supabase
      .from("exhibitor_categories")
      .delete()
      .eq("category_id", editingId);
    } else {
    const { data, error } = await supabase
      .from("category")
      .insert([{
        category_name: form.category_name,
        img_alt: form.img_alt,
        image: form.image,
        status: form.status
      }])
      .select()
      .single();

    if (error) return console.log(error.message);

    categoryId = data.id;
  }

  const linksPayload = form.exhibitors
    .filter(Boolean)
    .map((exhibitor_id) => ({
      category_id: categoryId,
      exhibitor_id}));

  if (linksPayload.length > 0) {
    await supabase.from("exhibitor_categories").insert(linksPayload);}

  setForm({
    category_name: "",
    img_alt: "",
    image: "",
    status: true,
    exhibitors: []});

  setEditingId(null);
  setOpen(false);

  const { data } = await supabase
    .from("category")
    .select("*")
    .order("id", { ascending: true });

  setCategories(data || []);
};




// // this is my deleete function

const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedDeleteId, setSelectedDeleteId] = useState(null);


const confirmDelete = async () => {
  const id = selectedDeleteId;


  await supabase
    .from("exhibitor_categories")
    .delete()
    .eq("category_id", id);


  const { error } = await supabase
    .from("category")
      .delete()
      .eq("id", id);

  if (error) {
    console.log(error.message);
    return;
  }

  setCategories((prev) => prev.filter((c) => c.id !== id));

     setShowDeleteModal(false);
  setSelectedDeleteId(null);
};







    return ( 
 <section className='information-container'>


        <article className='header-cont-event'>
                           <Header2
                            title="Categories Management"  
                            para="Manage exhibition categories and classifications"
                            />
                            
                          <AddCTA    title='Add Category'   
                          onClick={() => {
                          
                                    setOpen(true);
                                }}  
                                
                                />
                     
                            {open && (
                                <form className="overlay-create" onSubmit={handleSubmit}>
                                    <fieldset className="container-create">

                                    <div class="header-create">
                                        <h1 className="title-create">
                                     {editingId ? "Edit Category" : " Add Category"}
                                        </h1>
                                        <button className="close-btn-create" type="button" 
                                        onClick={() => {
                                            setOpen(false);
                                            setEditingId(null);
                                            }}>
                                        <img alt="close" src={pic30}/></button>
                                        </div>

                                    <Input
                                            title="Category Name"
                                            value={form.category_name} placeholder='Enter category name'
                                            onChange={(e) =>
                                            setForm({ ...form, category_name: e.target.value })
                                            }
                                        />
                                      <Errormsginput message={errors.category_name} />


                                            <Input
                                            title="Image URL"
                                            placeholder="Enter image link"
                                            value={form.image}
                                            onChange={(e) =>
                                                setForm({ ...form, image: e.target.value })
                                            }
                                            />


                                          <Input
                                        title="Pic Alt"   placeholder='Enter image name'
                                        value={form.img_alt}
                                        onChange={(e) =>
                                        setForm({ ...form, img_alt: e.target.value })
                                        }
                                    />



                                    <Selectinput
                                        title="Status"
                                        value={form.status}
                                        onChange={(e) =>
                                        setForm({ ...form, status: e.target.value === "true" })
                                        }
                                        options={[
                                        { value: "true", label: "Active" },
                                        { value: "false", label: "Inactive" }
                                        ]}
                                    />


                                       <div className='containerr-sub-inputs-category'>
                                    <h3>Exhibitors</h3>

                                  {form.exhibitors.map((ex, index) => (
                                        <div key={index} className="exhibitor-row">
                                    <Selectinput
                                    title={`Exhibitor ${index + 1}`}
                                    value={ex}
                                    onChange={(e) => updateExhibitor(e.target.value, index)}
                                    options={[
                                        { value: "", label: "Select exhibitor" },
                                        ...exhibitors.map((item) => ({
                                        value: item.id,
                                        label: item.exhibitor_name
                                        }))
                                    ]}
                                    />

                                    {editingId && (
                                    <button
                                        type="button"
                                        className="delete-exhibitor-btn"
                                        onClick={() => removeExhibitor(index)}
                                    >
                                        ✕
                                    </button>
                                    )}
                                </div>
                                ))}
   
                                 
                                    <button
                                    type="button"
                                    className="upload-ctaa"
                                    onClick={addExhibitorSelect}
                                    >
                                    <img src={pic44} alt="add" className="add-icon" />
                                    <h2 className='text-uploadd-cta'>Add Exhibitor</h2>
                                    </button>

                                                               <Errormsginput message={errors.exhibitors} />
                                </div>

                                    <nav className='container-ctas-craete'>
                                          <Cta
                                           title={editingId ? "Update Category" : "Create Category"}
                                            className="cta-create"
                                            type="submit"
                                            />
                                            <button className='cta-cancel-create' onClick={() => {
                                            setOpen(false);
                                                setEditingId(null);
                                            }}>
                                            <h2 className='cta-cancel-text-create'>  Cancel</h2>
                                            </button>
                                    </nav>
                                    </fieldset>
                                </form>
                                )}  

                                
                                  
        </article>


          <section className='container-table-eventp'>




                                        {showDeleteModal  && (
                                                <section className="delete-modal-overlay">
                                                    <article className="delete-modal">

                                                    <header className="delete-modal-header">
                                                        <div className="delete-icon-wrapper">
                                                        <img src={pic31} alt='icon' />
                                                        </div>

                                                        <div className="delete-text-container">
                                                        <h2 className="delete-title">Delete Category</h2>
                                                        <p className="delete-description">
                                                            Are you sure you want to delete this Category?
                                                        </p>
                                                        </div>
                                                    </header>

                                                    <nav className="container-ctas-craete">

                                                       <Cta 
                                                         onClick={confirmDelete}
                                                        title='Delete'
                                                       className="cta-create"
                                                       type="button" />

                                                    <button className='cta-cancel-create' 
                                                    onClick={() => {
                                                        setShowDeleteModal(false);
                                                        setSelectedDeleteId(null);
                                                    }}>
                                                    <h2 className='cta-cancel-text-create'>  Cancel</h2>
                                                    </button>
                                                              
                                                                
                                                    </nav>

                                                    </article>
                                                </section>
                                                )}





                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search events..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic26} className="search-icon" alt="search" />
                            </fieldset>

                            <fieldset className='container-inputs-event-p'>
                                    <div className="select-wrapper">
                                                <img src={pic25} className="arrow-icon" alt="arrow" />
                                                <img src={pic24} className="select-icon" alt="filter" />
<select
                                        className="input-search select-style"
                                        value={filter}
                                        onChange={(e) => setFilter(e.target.value)}
                                        >
                                            <option value="">Sort By</option>
                                        <option value="">All</option>
                                        <option value="true">Active</option>
                                        <option value="false">Inactive</option>
                                        </select>
                                     </div>


                            </fieldset>



                             <div className="table-container" >
                                <table className='table'>
                                    <thead>
                                    <tr className='table-header'>
                                        <th className='table-header-text'></th>
                                        <th className='table-header-text'>ID</th>
                                        <th className='table-header-text'>Category Name</th>
                                        <th className='table-header-text'>Exhibitors</th>
                                        <th className='table-header-text'>Status</th>
                                        <th className='table-header-text'>pic alert</th>                                                                                                                                                                                                                                       
                                        <th className='table-header-text'>Actions</th>
                                    </tr>
                                    </thead>

                               {currentCategories.map((item) => {
                                    const exhibitorCount = links.filter(
                                        (link) => link.category_id === item.id
                                    ).length;

                                    return (
                                    <tbody key={item.id}>
                                            <tr className='table2-header'>
                                                <td className='checkbox-cont-table'>
                                                    <label className="custom-checkbox">
                                                    <input type="checkbox"  className='checkboxxx'/>
                                                    <span className="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td className='mainwhite-table-font'>{item.id}</td>
                                                <td className='container-event3'>
                                                    <img className='img-tabel-event' src={item.image} alt='pic'></img>
                                                   <h2 className='event-title'> {item.category_name}</h2> 
                                                </td>
                                                <td className='mainwhite-table-font'> 
                                                   {exhibitorCount}</td>

                                                 <td className='mainwhite-table-font'>
                                                    <div className={getStatusClass(item.status)}>
                                                        <span className="time-recent-booking">
                                                        {getStatusLabel(item.status)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td className='mainwhite-table-font'>
                                                    {item.img_alt}
                                                </td>
                                            
                                                <td className='mainwhite-table-font'>
                                                    <nav className='cta-table'>

                                                            <button
                                                            className='cta2-table'
                                                            
                                                            >
                                                                <img src={pic27} alt='edit' />
                                                            </button>



                                                           <button
                                                            className='cta2-table'
                                                             onClick={async () => {
                                                                setOpen(true);
                                                                setEditingId(item.id);

                                                            const { data: linksData } = await supabase
                                                            .from("exhibitor_categories")
                                                                .select("exhibitor_id")
                                                            .eq("category_id", item.id);

                                                                setForm({
                                                                  category_name: item.category_name,
                                                                img_alt: item.img_alt,
                                                                image: item.image,
                                                                  status: item.status,
                                                                exhibitors: linksData.map((l) => l.exhibitor_id)
                                                                });
                                                            }}
                                                            >

                                                            <img src={pic28} alt='edit' />
                                                            </button>
                                                            


                                                            <button
                                                            className='cta2-table'

                                                            
                                                            >
                                                                <img src={pic29} alt='delete' 
                                                                  onClick={() => {
                                                                setSelectedDeleteId(item.id);
                                                                setShowDeleteModal(true);
                                                            }}
                                                            />
                                                            </button>
                                                            
                                                    </nav>
                                                </td>




                                            </tr>
                                    </tbody>
                                   );
                                        })}
                                </table>
                                </div>

                                       




            </section>

            <nav className="pagination-container">

            <button
                className="pagination-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}>
                Prev
            </button>

            <section className="pagination-numbers">
                {[...Array(totalPages)].map((_, index) => (<button
                    key={index}
                    className={
                    currentPage === index + 1
                        ? "pagination-number active-page"
                        : "pagination-number"
                    }
                    onClick={() => setCurrentPage(index + 1)}>
                    {index + 1}</button>
                ))}
            </section>

            <button
                className="pagination-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}>
                Next
            </button>

            </nav>


    </section>
     );
}
 
export default Categoriescontent;